import { Box, Link, Paper, Typography } from "@mui/material";
import { FAKE_TEXT } from "helpers/constants";
import { FC } from "react";

type Step3Props = {
  requirements: any[];
};

export const Step3: FC<Step3Props> = ({ requirements }) => {
  return (
    <>
      <Typography variant="h4" gutterBottom>
        Observe Your Student Perform the Task
      </Typography>
      <Typography variant="body1" gutterBottom>
        {FAKE_TEXT.LONG2X}
      </Typography>

      <Typography variant="h5">Competency Skill to be Observed</Typography>

      {requirements.length === 0 && (
        <Box mt={2}>
          <Typography variant="body1" color="textSecondary">
            No requirements added yet
          </Typography>
        </Box>
      )}

      <Box>
        {requirements.map((requirement) => (
          <Box>
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                my: 2,
                background: "rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Typography variant="body1" fontWeight={600}>
                {requirement.requirementName}
              </Typography>
              <Typography variant="body1">
                {requirement.fullDescription}
              </Typography>
              <Box display="flex" justifyContent="flex-end">
                <Link>See Success Rubric</Link>
              </Box>
            </Paper>
          </Box>
        ))}
      </Box>
    </>
  );
};
